var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckoutColorfinder = function SvgCheckoutColorfinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.525,
    cy: 20.524,
    r: 13.507,
    stroke: "#fff",
    transform: "rotate(-45 20.525 20.524)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#checkout-colorfinder_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "checkout-colorfinder_svg__b",
    width: 19,
    height: 19,
    x: 11,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.527,
    cy: 20.523,
    r: 9.191,
    fill: "#D9D9D9",
    transform: "rotate(-45 20.527 20.523)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#checkout-colorfinder_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#checkout-colorfinder_svg__c)",
    d: "M7.528 20.523h18.383v18.383H7.528z",
    transform: "rotate(-45 7.528 20.523)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.295 30.942 1.65-1.651 9.166 9.165-1.652 1.65z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "checkout-colorfinder_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 -6.498 23.217)scale(9.19124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#F1F43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#4C89E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5243"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "checkout-colorfinder_svg__a",
    width: 20.382,
    height: 20.383,
    x: 10.336,
    y: 10.332,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6931_6430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6931_6430",
    result: "shape"
  })))));
};
export default SvgCheckoutColorfinder;